
<template>
  <div class="paperDetail-page-container">
    <exam-header>
      <div slot="extend" class="paperDetail-page-header-btns" v-show="canMark">
        <el-button type="primary" @click="handleNext('prev')" class="pre-btn btn">上一张</el-button>
        <el-button @click="handleNext('next')" class="next-btn btn">下一张</el-button>
      </div>
    </exam-header>
    <div class="paper-info">
      <div class="paper-title-container">
        <div class="title-warp">
          <div class="left"><span class="title-icon"></span>{{checkType === 'preview' ? '查看试卷' : '批改试卷'}}</div>
        </div>
        <div class="paper-info-warp">
          <p class="info-bold">{{EXAM_LEVEL_TYPE_ENUM[userExam?.level || 'MATHS_TALENTS_1']}}</p>
          <!-- <p>试卷状态：{{status[userExam?.markStatus]}}</p> -->
          <p class="paper-name">考试名称：<span>{{userExam?.roundName}}</span></p>
          <p>考生姓名：{{userExam?.username}}</p>
          <p>考试时间：{{userExam?.startTime | formatDate}}</p>
          <div class="info-tag" :class="`status-${userExam?.markStatus}`">{{ userExam?.markStatus | formatStatus }}</div>
        </div>
      </div>
      <div class="paper-ques-container">
          <div class="question-list-warp" v-for="(item,index) in Object.keys(userQuestions)" :key="index">
            <div class="left">
              <div class="question-type"><span/>{{QuestionTypeMap[item]}}作答情况</div>
              <div v-if="item === 'PICTURE_BLANK_FILLING' || item === 'PICTURE_PROOF'" class="question-item-list">
                <div class="question-temp-warp" v-for="(temp,i) in userQuestions[item]" :key="i">
                  <question-template
                  :canMark="canEdit"
                  @remark-change="onRemarkChange(item, i, $event)"
                  @score-change="onScoreChange(item, i, $event)"
                  :question-data="temp" :q-index="i +1" :question-type="item"></question-template>
                </div>
              </div>
              <div v-else class="question-list-row">
                <!-- 系统自动判题：单选题、多选题、填空题 -->
                <span v-for="(ques,i) in userQuestions[item]"
                        :class="[{
                          'item-block': true,
                          'wrong' : ques.validationStatus === 'WRONG',
                          'correct': ques.validationStatus === 'CORRECT',
                          'noActive': ques.validationStatus === 'NOTACTIVE',
                        }]"
                  :key="i">{{ i < 10 ? `0${i +1}` : i+1}}</span>
              </div>
            </div>
            <div class="right">
              <div class="title">得分情况:</div>
              <template v-if="groupStatMap[item]">
                <div class="score-box">{{ groupStatMap[item].totalScore }}分</div>
                <p class="score-info">
                    共计{{ groupStatMap[item].total }}题，
                    {{ groupStatMap[item].notActive }}题未作答，
                    答对{{ groupStatMap[item].correct }}题，
                    答错{{ groupStatMap[item].wrong }}题
                  </p>
              </template>
              <div class="score-box" v-else>
                {{ getOtherTypeScore(item) }}分
              </div>
            </div>
          </div>
      </div>
      <div class="paper-bottom" >
        <div class="user-score-warp">
          <div class="score-detail">
            <p class="score">用户成绩总分：{{totalScore}}分</p>
            <div class="paper-status" v-if="canMark">
              <p class="status" v-if="hasChanged">内容待保存</p>
              <p class="status status-check" v-else-if="userExam?.markStatus === 1 || userExam?.markStatus === 2">内容已保存</p>
              <p class="status status-check" v-if="userExam?.markStatus === 2 ">成绩已核对完成</p>
            </div>
          </div>
          <div class="bottom-btns" v-if="canMark">
            <el-button type="primary" @click="handleSave" :disabled="userExam?.markStatus === 2">保存</el-button>
            <el-popover width="200" placement="top"
                        v-model="visible"
                        popper-class="check-popover" trigger="click">
              <span class="ic"/>
              <p class="text">请仔细核对分数，核对后成绩用户可见</p>
              <div class="check-popover-btn">
                <el-button size="mini" type="text" @click="visible = false" class="btn">取消</el-button>
                <el-button type="primary" size="mini" @click="()=> {
                  this.visible = false;
                  this.handlePublish()
                }" class="btn">确定</el-button>
              </div>
              <el-button type="primary"  :disabled="userExam?.markStatus === 2" slot="reference">成绩完成核对</el-button>
            </el-popover>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {Button, Message,Popover} from 'element-ui';
import {QuestionTypeMap, EXAM_LEVEL_TYPE_ENUM} from '@/common/constant/qz';
import {getExamPaperDetail, getExamPaperNext, saveCheckPaper} from "@/api/qzTeacher";
import ExamHeader from "./components/teacherExamHeader.vue";
import QuestionTemplate from "./components/quesTemplate";
import dayjs from 'dayjs';

export default {
  name:'PaperDetailPage',
  components: {
    'el-button': Button,
    'exam-header': ExamHeader,
    'question-template': QuestionTemplate,
    'el-popover': Popover,
  },
  computed: {
    canEdit() {
      return this.canMark && this.userExam?.markStatus !== 2;
    },
    totalScore() {
      let total = 0;
      Object.keys(this.userQuestions).forEach(type => {
        this.userQuestions[type].forEach(q => {
          total += q.points || 0;
        });
      });
      return total;
    }
  },
  filters: {
    formatDate(date) {
      return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
    },
    formatStatus(status) {
      const statusMap = {
        0: '待批改',
        1: '批改中',
        2: '成绩已核对'
      }
      return statusMap[status] || '待批改';
    }
  },
  data(){
    return {
      userExam:null,
      EXAM_LEVEL_TYPE_ENUM,
      userQuestions:[],
      QuestionTypeMap,
      paperId:'',
      level:'MATHS_TALENTS_1',
      scale:1,
      visible:false,
      checkType:'',
      canMark:true,
      markStatus:0,
      userName:null,
      hasChanged:false,
      groupStatMap:{},
    }
  },
  created() {
    const { paperId, checkType } = this.$route.query;
    this.checkType = checkType;
    this.paperId = paperId;
    this.$nextTick(() => {
      this.getPaperDetail(this.paperId);
    })
  },
  methods: {
    // 获取上下张试卷
    getNextPaperDetail(type) {
      const filters = JSON.parse(sessionStorage.getItem('filterData')) || {};
      const { markMode } = this.$route.query;
      getExamPaperNext({
        ...filters,
        direction:type === 'prev' ? -1 : 1,
        currentUserExamId:this.paperId,
        markMode:markMode === 'NORMAL' ? '' : 'CROSS',
      }).then(res => {
        if(res.code === 200 && res.body?.userExam?.id){
          const userExam = res.body.userExam;
          const router = this.$router.resolve({
            name: this.$route.name,
            query: {
              ...this.$route.query,
              paperId: userExam.id
            }
          });
          window.location.href = router.href;
        }else{
          if(type === 'prev'){
            Message.warning('没有上一张试卷')
          }else{
            Message.warning('没有下一张试卷')
          }
        }
      })
    },
    // 处理题目和规则的关系
    formatQuestionData(data, rule) {
      if (!rule) {
        Message({
          type: 'error',
          duration: 0,
          message: '当前试卷配置规则不存在，请联系管理员',
        })
        return data;
      }
      rule = rule.intervals.sort((a, b) => a.start - b.start);
      rule.forEach(interval => {
        for (let i = interval.start - 1; i < interval.end; i++) {
          if (data[i]) {
            data[i].contentPayload.score = parseInt(interval.score);
            data[i].contentPayload.start = interval.start;
            data[i].contentPayload.end = interval.end;
          }
        }
      });
      return data;
    },
    getPaperDetail(paperId){
      getExamPaperDetail(paperId).then((res) => {
        if(res.code === 200 && res.body){
          // res.body.userQuestions.forEach(item => {
          //   item.points = typeof item.points === 'number' ? item.points / 10 : undefined;
          //   item.remark = item.validatePayload?.scoreDesc || '';
          //   return item
          // })
          const formatQuestions = res.body.userQuestions.map(item => ({
            ...item,
            points: typeof item.points === 'number' ? item.points / 10 : undefined,
            remark: item.validatePayload?.scoreDesc || ''
          }))
          const rule_questions = this.formatQuestionData(formatQuestions, res.body.rule);
          this.userQuestions = this.groupedQuestions(rule_questions);
          this.userExam = res.body.userExam;
          this.canMark =  res.body.userExam?.canMark || res.body.userExam?.canMark === null;
          ['TEXT_CHOICE_QUESTION', 'TEXT_MULTI_CHOICE', 'BLANK_FILLING'].forEach(type => {
            this.groupStatMap[type] = this.getGroupStat(type);
          })
          console.log(this.groupStatMap)
        }
      })
    },
    getGroupStat(type) {
      if (!this.userQuestions[type]) return null;
      const arr = this.userQuestions[type] || [];
      let correct = 0, wrong = 0, notActive = 0, totalScore = 0;
      arr.forEach(q => {
        totalScore += q.points || 0;
        if (q.validationStatus === 'CORRECT') {
          correct++;
        } else if (q.validationStatus === 'WRONG') {
          wrong++;
        } else if (q.validationStatus === 'NOTACTIVE') {
          notActive++;
        }
      });
      return {
        total: arr.length,
        correct,
        wrong,
        notActive,
        totalScore:totalScore
      }
    },
    groupedQuestions (userQuestions) {
      return userQuestions.reduce((acc, question) => {
        const {questionType} = question;
        if (!acc[questionType]) {
          acc[questionType] = [];
        }
        acc[questionType].push(question);
        return acc;
      }, {})
    },
    onScoreChange(type, index, payload) {
      // type: 题型, index: 题目在该类型下的下标, payload: { index, score }
      if (this.userQuestions[type] && this.userQuestions[type][index]) {
        this.$set(this.userQuestions[type][index], 'points', payload.score);
        this.$set(this.userQuestions[type][index], 'changed', true);
        this.hasChanged = true;
      }
    },
    onRemarkChange(type, index, payload) {
      // type: 题型, index: 题目在该类型下的下标, payload: { index, remark }
      if (this.userQuestions[type] && this.userQuestions[type][index]) {
        this.$set(this.userQuestions[type][index], 'remark', payload.remark);
        this.$set(this.userQuestions[type][index], 'changed', true);
        this.hasChanged = true;
      }
    },
    getOtherTypeScore(type) {
      const arr = this.userQuestions[type] || [];
      // 只统计有分数的题目
      return arr.reduce((sum, q) => sum + (q.points || 0), 0);
    },
    submitPaperStatus (markStatus) {
      const questions = []
      Object.keys(this.userQuestions).forEach(type => {
        this.userQuestions[type].filter(item => item.changed).forEach(q => {
          questions.push({
            questionId: q.courseExamInstanceQuestionId,
            points: (q.points * 10 || 0), // 乘以10
            validatePayload: q.remark ? {
              scoreDesc: q.remark
            } : undefined
          })
        })
      })
      const params = {
        userCourseExamRelationInstanceId: this.paperId,
        markStatus,
        questions
      }
      saveCheckPaper(params).then(res => {
        if(res.code === 200 && res.body.result) {
          this.$message({
            type: 'success',
            offset:200,
            message: markStatus === 1 ? '保存成功' : '操作成功'
          })
          this.hasChanged = false;
          this.getPaperDetail(this.paperId);  //更新试卷状态
        }
      })
    },
    // 保存
    handleSave() {
      this.submitPaperStatus(1)
    },
    // 成绩已核对
    handlePublish() {
      this.submitPaperStatus(2)
    },
    // 上/下一张
    handleNext(type) {
      if(this.userExam?.markStatus === 2 || !this.canMark || !this.hasChanged){
        this.getNextPaperDetail(type)
        return
      }
      this.$confirm('即将前往其他试卷，当前编辑内容是否保存','提示',{
        confirmButtonText: '保存',
        cancelButtonText: '不保存',
        distinguishCancelAndClose: true,
        showCancelButton: true,
        type: 'warning'
      }).then(() => {
        this.handleSave();
        this.$nextTick(() => {
          this.getNextPaperDetail(type)
        })
      }).catch((action) => {
        console.log(action,'action')
        if(action === 'cancel'){
          this.getNextPaperDetail(type)

        }
      })
    },
  }
}
</script>

<style scoped lang="less">
.paperDetail-page-container{
  background: #EDE4DA;
  min-height: 100vh;
  padding: 72px 0;
  box-sizing: border-box;
  .paperDetail-page-header-btns{
    .btn{
      width: 106px;
      height: 36px;
      border-radius: 90px;
      font-size: 14px;
      border: none;
    }
    .pre-btn {
      color: #FFFFFF;
      background: #E60012;
    }
    .next-btn{
      color: #000000;
      background: #F2F3F5;
    }
  }
  .paper-info {
    //max-width: 1200px;
    width: 1200px;
    margin: 24px auto 0;
    background: #F7F6F5;
    border-radius: 12px;
    overflow: hidden;
    .paper-title-container{
      background: #fff;
      padding: 24px 38px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .title-warp{
        display: flex;
        flex-shrink: 0;
        justify-content: space-between;
        margin-right: 24px;
        .left{
          display: flex;
          align-items: center;
          font-size: 24px;
          font-weight: 600;
          color:#000000;
          white-space: nowrap;
          .title-icon{
            width: 30px;
            height: 30px;
            background: url("@/common/images/teacher/ic_paper.png") center / contain no-repeat;
            margin-right: 3px;
          }
        }
      }
      .paper-info-warp{
        display: flex;
        flex: 1;
        align-items: center;
        color:#4E5969;
        p{
          white-space: nowrap;
          font-size: 14px;
          margin-right: 25px;
          font-weight: 500;
          &.paper-name{
            display: flex;
            align-items: center;
            span{
              white-space: normal;
              text-align: left;
            }
          }
        }
        .info-bold {
          font-size: 14px;
          color: #000000E5;
          font-weight: 600;
        }
        .info-tag {
          margin-left: auto;
          display: inline-flex;
          align-items: center;
          height: 36px;
          box-sizing: border-box;
          background: #E8F7E8;
          border-radius: 4px;
          padding: 7px 16px;
          font-size: 14px;
          color: #000000E5;
          font-weight: 500;
          white-space: nowrap;
          &.status-0 {
            background: #FAEBEB;
          }
          &.status-1 {
            background: #FAEBEB;
          }
          &.status-2 {
            background: #E8F7E8;
          }
        }
      }
    }
    .paper-ques-container{
      width: 100%;
      padding: 20px 20px 38px;
      box-sizing: border-box;
      background: #F7F6F5;
      //height: calc(100vh - 430px);
      //overflow-y: scroll;
      .question-list-warp{
        background: #FFFFFF;
        width: 100%;
        box-sizing: border-box;
        padding: 28px 36px 36px;
        border-radius: 12px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 24px;
        .left{
          width: 62%;
          padding-right: 34px;
          border-right: 1px solid #E4E7ED;
          .question-type{
            color: #000;
            font-size: 24px;
            font-weight: 600;
            display: flex;
            align-items: center;
            span{
              width: 5px;
              height: 24px;
              margin-right: 12px;
              background: #BD9F68;
              border-radius: 90px;
            }
          }
          .question-item-list{
            margin-top: 24px;
            text-align: left;
          }
          .question-list-row {
            margin-top: 24px;
            text-align: left;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            .item-block {
              width: 62px;
              height: 62px;
              margin: 0 16px 20px 0;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 18px;
              font-weight: 600;
              background: #F5F6F9;
              border-radius: 4px;
              &.wrong{
                background: #FAEBEB;
                color: #FC474C;
              }
              &.correct{
                background: #E8F7E8;
                color: #19B21E;
              }
              &.noActive{
                background: #F5F6F9;
                color: #4E5969;
              }
            }
          }
        }
        .right{
          width: 38%;
          height: 100%;
          position: relative;
          flex: 1;
          text-align: left;
          padding-left: 36px;
          box-sizing: border-box;
          .title{
            color: #000;
            font-size: 24px;
            font-weight: 600;
            margin-bottom: 16px;
          }
          .score-box{
            background: #F5F6F9;
            border-radius: 8px;
            height: 94px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 36px;
            font-weight: bold;
          }
          .score-info{
            margin-top: 12px;
            color: rgba(125, 128, 135, 0.9);
            font-size: 16px;
          }
        }
      }
    }
    .paper-bottom{
      height: 88px;
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 2;
      .user-score-warp{
        box-shadow: 0 -5px 10px rgba(0, 0, 0, 0.1);
        background: #FFFFFF;
        border-radius: 0 0 12px 12px;
        margin:  0 auto;
        width: 1200px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 24px;
        box-sizing: border-box;
        .score-detail{
          display: flex;
          justify-content: center;
          align-items: center;
          .score{
            font-size: 22px;
            color: #000;
            font-weight: 500;
          }
          .paper-status{
            display: flex;
            align-items: center;
            margin-left: 28px;
            font-size: 18px;
            color: #7D8087;
            .status{
              margin-right: 28px;
              display: flex;
              align-items: center;
            }
            .status-check {
              background: url("@/common/images/teacher/ic_check.png") left / contain no-repeat;
              padding-left: 29px;
            }
          }
        }
        .bottom-btns{
          margin-top: 24px;
          .el-button{
            width: 172px;
            height: 48px;
            border-radius: 24px;
            font-size: 16px;
            margin-right: 24px;
            border: none;
            &.is-disabled{
              opacity: 0.6;
            }
            &:first-child{
              background: #F2F3F5;
              color: #1D2129;
            }
            &:last-child{
              background:#E81021;
              color: #FFFFFF;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.check-popover{
  width: 201px;
  box-sizing: border-box;
  height: 138px;
  border: 1px solid rgba(255, 213, 213, 1);
  box-shadow: 0 4px 4px 0 rgba(209, 209, 209, 0.25);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  //align-items: center;
  justify-content: center;
  position: relative;
  .ic{
    width: 46px;
    height: 46px;
    background: url("@/common/images/teacher/ic_warning.png") center / contain no-repeat;
    position: absolute;
    top: -23px;
    right: 0;
  }
  .text{
    font-size: 12px;
    color: #666666;
    margin-top: 20px;
  }
  .check-popover-btn{
    margin-top: 21px;
    display: flex;
    align-items: center;
    .btn{
      width: 80px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      border-radius: 24px;
      &:first-child{
        color: #1D2129;
        background: #F2F3F5;
      }
      &:last-child{
        background: #080808;
        color: #FFFFFF;
      }
    }
  }
}
</style>